export function orderData(response, arr) {
	const hash = response.reduce(function (prev, curr) {
		prev[curr.id] = curr;
		return prev;
	}, {});
	const orderedData = arr.map((id) => hash[id]);
	return orderedData;
}
